
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import RoutesSettings from './RoutesSettings';





function App() {
  
  return (
      <RoutesSettings />
  );
}

export default App;
